import { app } from '../../../../../app';
import { Controller } from './unassign-group.controller';

app.component('companyManageApplicationUsersUnassignGroup', {
    bindings: {close: '&', dismiss: '&', resolve: '<'},
    controller: Controller,
    templateUrl: require('./unassign-group.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/manage-application/users/unassign-group/unassign-group.component.js